"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function InnerCard(_ref) {
  let {
    data,
    isBundle,
    showFeaturedPackages,
    showLibraries,
    showPlatforms,
    showRatings,
    showVerification,
    height,
    showChannel
  } = _ref;
  let featuredCharms = [];
  if (data.package.charms) {
    featuredCharms = data.package.charms.slice(0, 5);
  }
  const stars = [];
  let ratings = null;
  let totalRatings = null;
  if (data.ratings && data.ratings.value) {
    ratings = data.ratings.value;
  }
  if (data.ratings && data.ratings.count) {
    totalRatings = data.ratings.count;
  }
  for (let i = 1; i <= 5; i++) {
    let className = "p-icon--star-empty";
    if (i <= ratings) {
      className = "p-icon--star-filled";
    } else if (i - ratings === 0.5) {
      className = "p-icon--star-half-filled";
    }
    stars.push(/*#__PURE__*/_react.default.createElement("i", {
      className: className,
      key: i
    }));
  }
  if (data.package.display_name === "") {
    data.package.display_name = data.package.name.replace(/-/g, " ");
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "sc-package-card",
    style: {
      width: "100%",
      height: height
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sc-package-card__body"
  }, isBundle && /*#__PURE__*/_react.default.createElement("div", {
    className: "sc-package-card__header"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "p-muted-heading u-no-margin--bottom"
  }, "Bundle")), data.package.display_name && /*#__PURE__*/_react.default.createElement("h2", {
    className: "sc-package-card__heading p-heading--5 u-no-margin--bottom"
  }, data.package.name ? /*#__PURE__*/_react.default.createElement("a", {
    className: "sc-package-card__heading-link",
    href: `/${data.package.name}`
  }, data.package.display_name) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.package.display_name)), data.publisher && /*#__PURE__*/_react.default.createElement("p", {
    className: `u-text--muted u-no-padding--top ${showChannel ? "u-no-margin--bottom" : ""}`
  }, /*#__PURE__*/_react.default.createElement("em", null, data.publisher.display_name, " "), showVerification && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.publisher.validation === "verified" && /*#__PURE__*/_react.default.createElement("img", {
    src: "https://assets.ubuntu.com/v1/ba8a4b7b-Verified.svg",
    width: 14,
    height: 14,
    alt: "Verified account",
    title: "Verified account",
    className: "sc-package-publisher-icon"
  }), (data.publisher.validation === "star" || data.publisher.validation === "starred") && /*#__PURE__*/_react.default.createElement("img", {
    src: "https://assets.ubuntu.com/v1/d810dee9-Orange+Star.svg",
    width: 14,
    height: 14,
    alt: "Star developer",
    title: "Star developer",
    className: "sc-package-publisher-icon"
  }))), showChannel && data.package.channel && /*#__PURE__*/_react.default.createElement("p", {
    className: "u-text--muted",
    "data-testid": "package-channel"
  }, data.package.channel.track === "latest" ? "latest/" : "", data.package.channel.risk), /*#__PURE__*/_react.default.createElement("p", {
    className: `u-line-clamp ${!showRatings && !showFeaturedPackages && !showPlatforms ? "u-no-margin--bottom" : ""}`
  }, data.package.description), showRatings && /*#__PURE__*/_react.default.createElement("div", {
    className: "star-rating",
    "data-testid": "ratings"
  }, stars, /*#__PURE__*/_react.default.createElement("span", {
    className: "total-ratings u-text--muted"
  }, totalRatings)), showFeaturedPackages && data.package.charms && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "featured-packages",
    className: "sc-charm-bundle-icons"
  }, featuredCharms.map(charm => /*#__PURE__*/_react.default.createElement("img", {
    src: `/${charm.name}/icon`,
    alt: "",
    title: charm.display_name,
    key: charm.name,
    width: 32,
    height: 32,
    className: "sc-charm-bundle-icon"
  })), data.package.charms.length - featuredCharms.length > 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: "sc-charm-bundle-count u-text--muted"
  }, "+", data.package.charms.length - featuredCharms.length)), showPlatforms && data.package.platforms && data.package.platforms.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "sc-package-card__footer"
  }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "sc-package-card__footer-content"
  }, showLibraries && /*#__PURE__*/_react.default.createElement("a", {
    href: `/${data.package.name}/libraries`,
    className: "sc-package-card__footer-link"
  }, "Libraries"), /*#__PURE__*/_react.default.createElement("div", {
    className: "sc-platform u-align--right"
  }, data.package.platforms.includes("vm") && /*#__PURE__*/_react.default.createElement("img", {
    className: "sc-platform-icon",
    src: "https://assets.ubuntu.com/v1/bf61e269-machine-badge.svg",
    width: 24,
    height: 24,
    alt: "Machine"
  }), data.package.platforms.includes("kubernetes") && /*#__PURE__*/_react.default.createElement("img", {
    className: "sc-platform-icon",
    src: "https://assets.ubuntu.com/v1/f1852c07-Kubernetes.svg",
    width: 24,
    height: 24,
    alt: "Kubernetes"
  })))))));
}
InnerCard.propTypes = {
  isBundle: _propTypes.default.bool,
  isHighlighted: _propTypes.default.bool,
  showFeaturedPackages: _propTypes.default.bool,
  showIcon: _propTypes.default.bool,
  showLibraries: _propTypes.default.bool,
  showPlatforms: _propTypes.default.bool,
  showRatings: _propTypes.default.bool,
  showVerification: _propTypes.default.bool,
  height: _propTypes.default.string,
  showChannel: _propTypes.default.bool
};
var _default = exports.default = InnerCard;